// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file fw_management/fw_management.proto (package fw_management, syntax proto3)
/* eslint-disable */

import { RPC } from "../runtime";

/**
 * @generated from message fw_management.FwIpRequest
 */
export type FwIpRequest = {
}
;
/**
 * @generated from message fw_management.FwIpResponse
 */
export type FwIpResponse = {
/**
 * @generated from field: repeated string fw_ips = 1;
 */
fwIps?: string[];
}
;
/**
 * @generated from message fw_management.FwPortRequest
 */
export type FwPortRequest = {
}
;
/**
 * @generated from message fw_management.FwPortResponse
 */
export type FwPortResponse = {
/**
 * @generated from field: repeated string fw_ports = 1;
 */
fwPorts?: string[];
}
;
/**
 * @generated from message fw_management.IngressUpdateRequest
 */
export type IngressUpdateRequest = {
/**
 * @generated from field: repeated string new_fw_ips = 1;
 */
newFwIps?: string[];
/**
 * @generated from field: string modified_by = 2;
 */
modifiedBy?: string;
/**
 * @generated from field: double timestamp = 3;
 */
timestamp?: number;
/**
 * @generated from field: fw_management.UserContext user_context = 4;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message fw_management.IngressUpdateResponse
 */
export type IngressUpdateResponse = {
/**
 * @generated from field: string status_update = 1;
 */
statusUpdate?: string;
}
;
/**
 * @generated from message fw_management.EgressUpdateRequest
 */
export type EgressUpdateRequest = {
/**
 * @generated from field: repeated string new_fw_ports = 1;
 */
newFwPorts?: string[];
/**
 * @generated from field: string modified_by = 2;
 */
modifiedBy?: string;
/**
 * @generated from field: double timestamp = 3;
 */
timestamp?: number;
/**
 * @generated from field: fw_management.UserContext user_context = 4;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message fw_management.EgressUpdateResponse
 */
export type EgressUpdateResponse = {
/**
 * @generated from field: string status_update = 1;
 */
statusUpdate?: string;
}
;
/**
 * @generated from message fw_management.IngressDeleteRequest
 */
export type IngressDeleteRequest = {
/**
 * @generated from field: repeated string deleted_fw_ips = 1;
 */
deletedFwIps?: string[];
/**
 * @generated from field: string modified_by = 2;
 */
modifiedBy?: string;
/**
 * @generated from field: double timestamp = 3;
 */
timestamp?: number;
/**
 * @generated from field: fw_management.UserContext user_context = 4;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message fw_management.IngressDeleteResponse
 */
export type IngressDeleteResponse = {
/**
 * @generated from field: string status_update = 1;
 */
statusUpdate?: string;
}
;
/**
 * @generated from message fw_management.EgressDeleteRequest
 */
export type EgressDeleteRequest = {
/**
 * @generated from field: repeated string deleted_fw_ports = 1;
 */
deletedFwPorts?: string[];
/**
 * @generated from field: string modified_by = 2;
 */
modifiedBy?: string;
/**
 * @generated from field: double timestamp = 3;
 */
timestamp?: number;
/**
 * @generated from field: fw_management.UserContext user_context = 4;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message fw_management.EgressDeleteResponse
 */
export type EgressDeleteResponse = {
/**
 * @generated from field: string status_update = 1;
 */
statusUpdate?: string;
}
;
/**
 * @generated from message fw_management.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from rpc fw_management.FWManagementService.GetFwIps
 */
export const FWManagementService_GetFwIps = new RPC<FwIpRequest,FwIpResponse>("GET", "/getFwIps");
/**
 * @generated from rpc fw_management.FWManagementService.GetFwPorts
 */
export const FWManagementService_GetFwPorts = new RPC<FwPortRequest,FwPortResponse>("GET", "/getFwPorts");
/**
 * @generated from rpc fw_management.FWManagementService.UpdateIngressRules
 */
export const FWManagementService_UpdateIngressRules = new RPC<IngressUpdateRequest,IngressUpdateResponse>("POST", "/updateIngressRules");
/**
 * @generated from rpc fw_management.FWManagementService.UpdateEgressRules
 */
export const FWManagementService_UpdateEgressRules = new RPC<EgressUpdateRequest,EgressUpdateResponse>("POST", "/updateEgressRules");
/**
 * @generated from rpc fw_management.FWManagementService.DeleteIngressRules
 */
export const FWManagementService_DeleteIngressRules = new RPC<IngressDeleteRequest,IngressDeleteResponse>("POST", "/deleteIngressRules");
/**
 * @generated from rpc fw_management.FWManagementService.DeleteEgressRules
 */
export const FWManagementService_DeleteEgressRules = new RPC<EgressDeleteRequest,EgressDeleteResponse>("POST", "/deleteEgressRules");
